export default class WorkerSummaryDto {
    firstName = '';
    lastName = '';
    emailAddress = '';
    mobilePhoneNumber = '';
    isOnPayroll = false;
}
